<template>
  <div class="sp-radio" :class="size">
    <p v-if="label">{{ label }}</p>
    <el-radio-group :value="value" @input="val => $emit('input', val)">
      <el-radio-button
        v-for="item of options"
        :key="item.value"
        :label="item.value"
        >{{ item.label }}</el-radio-button
      >
    </el-radio-group>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String, Boolean],
      require: true
    },
    options: {
      type: Array,
      require: true
    },
    label: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "small"
    }
  }
};
</script>

<style lang="less" scoped>
.sp-radio {
  display: flex;
  align-items: center;
  justify-content: space-between;
  > p {
    min-width: 72px;
    font-size: 12px;
    color: #999999;
    font-weight: 400;
  }
  /deep/ .el-radio-group {
    .el-radio-button:first-child .el-radio-button__inner {
      border-radius: 2px 0px 0px 2px;
    }
    .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0px 2px 2px 0px;
    }
    .el-radio-button__inner {
      background: #fff;
      border: 1px solid #eeeeee;
      font-size: 12px;
      color: #333333;
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background: #ecf4ff;
      border: 1px solid #2154f4;
      color: #2154f4;
    }
  }
}

.small {
  /deep/ .el-radio-group {
    .el-radio-button__inner {
      padding: 8px 9px;
    }
  }
}

.big {
  /deep/ .el-radio-group {
    .el-radio-button__inner {
      padding: 11px 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/SpRadio.vue